import { createGlobalState } from '@vueuse/core'
import get from 'lodash/get'
import { computed } from 'vue'

export const useTeamExtra = createGlobalState(() => {
  const disableAiAssistant = computed(() => get(Spark.state.currentTeam, ['extra', 'disable_ai_assistant'], false))
  const disableOttoChat = computed(() => get(Spark.state.currentTeam, ['extra', 'disable_otto_chat'], false))
  const disableSalesAssistant = computed(() => get(Spark.state.currentTeam, ['extra', 'disable_sales_assistant'], false))

  return {
    disableAiAssistant,
    disableOttoChat,
    disableSalesAssistant,
  }
})
